var hasSentEvent = false;

if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function (str, newStr) {

        // If a regex pattern
        if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
            return this.replace(str, newStr);
        }

        // If a string
        return this.replace(new RegExp(str, 'g'), newStr);

    };
}

function maintenanceMileageResponse() {
    var milageArray = $('#validMileage').data('mileagearray').split("|");

    var mileage = $('.vehicle-payment-form').find("select.mileage").val(),
        maintenance = $('.vehicle-payment-form').find('select.inc-maintenance-option').val();

    var responseAlert = $('.mileage-price').find('a');

    if (milageArray.indexOf(mileage) !== -1 && maintenance === "1") {
        $('.mileage-price').slideDown();
        responseAlert.text('Maintenance - Confirm Quote For Price');
    }
    else if (milageArray.indexOf(mileage) === -1 && maintenance !== "1") {
        $('.mileage-price').slideDown();
        responseAlert.text('Mileage - Confirm Quote For Price');
    }
    else if (milageArray.indexOf(mileage) === -1 && maintenance === "1") {
        $('.mileage-price').slideDown();
        responseAlert.text('Mileage & Maintenance - Confirm Quote For Price');
    }
    else {
        $('.mileage-price').slideUp();
    }
}

function RefreshDropdowns() {
    $('.selectpicker[name="PricingType"]').selectpicker('refresh');
    $('.selectpicker[name="InitialRental"]').selectpicker('refresh');
    $('.selectpicker[name="ContractTerm"]').selectpicker('refresh');
    $('.selectpicker[name="MaintenanceType"]').selectpicker('refresh');
    $('.selectpicker[name="AnnualMileage"]').selectpicker('refresh');
}

function DesktopPricingChanges(pricingType) {
    if (pricingType === 'Personal') {
        $('.personal_button').removeClass('btn-filter-inactive').addClass('is-active');
        $('.business_button').removeClass('is-active').addClass('btn-filter-inactive');
        $('label[for="form-contract-type-business"]').removeClass('checked');
        $('label[for="form-contract-type-personal"]').addClass('checked');
        $('#form-contract-type-personal').attr('checked', true);
        $('#form-contract-type-business').attr('checked', false);
    }
    else if (pricingType === 'Business') {
        $('.business_button').removeClass('btn-filter-inactive').addClass('is-active');
        $('.personal_button').removeClass('is-active').addClass('btn-filter-inactive');
        $('label[for="form-contract-type-personal"]').removeClass('checked');
        $('label[for="form-contract-type-business"]').addClass('checked');
        $('#form-contract-type-business').attr('checked', true);
        $('#form-contract-type-personal').attr('checked', false);
    }
    $(".contract-type").val(pricingType);
}

function DesktopMinimumPricingChanges(pricingType) {
    if (pricingType === 'Personal') {
        $('.personal_button').removeClass('btn-filter-inactive').addClass('is-active');
        $('.business_button').removeClass('is-active').addClass('btn-filter-inactive');
    }
    else if (pricingType === 'Business') {
        $('.business_button').removeClass('btn-filter-inactive').addClass('is-active');
        $('.personal_button').removeClass('is-active').addClass('btn-filter-inactive');
    }
    $(".contract-type").val(pricingType);
}

function updatePricesFromTopBar() {
    $('.js-options-loader').fadeIn();
    var form = $("#vehicle-filter-form");
    var pricingType = $(this).html();
    $.ajax(
        {
            url: form.attr('action'),
            data: "PricingType=" + pricingType + "&InitialRental=" + $('#dropdownInitialRental').val() + "&ContractTerm=" + $('#dropdownContractTerm').val() + "&AnnualMileage=" + $('#dropdownAnnualMileage').val() + "&MaintenanceType=" + $('#dropdownMaintenanceType').val(),
            type: "GET",
            success: function (data) {
                DesktopPricingChanges(pricingType);
                $("#pricing-result-no-fixed").html(data);
                if ($(window).width() > 992) {
                    $('.detail__action-btns').appendTo('#fixed-pricing');
                    $('#pricing-result').addClass('stick-area');
                }
                updateOptions();
                RefreshDropdowns();
                updateP11D();
                if ($('#monthlyPayments').text().length > 1) {
                    $('#blue-bar-monthly-price').show();
                    $('.js-vehicle-price').text($('#monthlyPayments').text());
                } else {
                    $('#blue-bar-monthly-price').hide();
                }
                $('.js-vehicle-price').text($('#monthlyPayments').text());
                $('.js-initial-price').text($('#initialPayment').text());
                $('.vat-display-change').text($('.vat-display-change.text-smaller').text());
                $('.u-vat').text($('.vat-display-change.text-smaller').text());
                $('.js-options-loader').fadeOut();
            }
        });
}

function updatePrices() {

    if (hasSentEvent == false) {
        var cookieConsent = document.cookie.indexOf('cookieconsent_status');
        if(cookieConsent > 0) {
            var notSentEventCustomProductId = makeid(10);
            fbq('track', 'CustomizeProduct', {}, {eventID: notSentEventCustomProductId});
            $.ajax({
                url: '/umbraco/api/FacebookPixelAPI/TrackFacebookEvent',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    EventID: notSentEventCustomProductId,
                    RawEventName: 'CustomizeProduct'
                }),
                success: function (apiResponse) {
                }
            });
        }
        hasSentEvent = true;
    }

    $('.js-options-loader').fadeIn();
    var form = $("#vehicle-filter-form");
    var pricingType = $('#dropdownPricingType').val();
    cookies.set("pt", pricingType, 30);
    $.ajax(
        {
            url: form.attr('action'),
            data: form.serialize(),
            type: "GET",
            success: function (data) {
                DesktopPricingChanges(pricingType);
                $("#pricing-result-no-fixed").html(data);
                if ($(window).width() > 992) {
                    $('.detail__action-btns').appendTo('#fixed-pricing');
                    $('#pricing-result').addClass('stick-area');
                }
                updateOptions();
                RefreshDropdowns();
                updateP11D();
                if ($('#monthlyPayments').text().length > 1) {
                    $('#blue-bar-monthly-price').show();
                    $('.js-vehicle-price').text($('#monthlyPayments').text());
                } else {
                    $('#blue-bar-monthly-price').hide();
                }
                $('.js-initial-price').text($('#initialPayment').text());
                $('.vat-display-change').text($('.vat-display-change.text-smaller').text());
                $('.u-vat').text($('.vat-display-change.text-smaller').text());
                cookies.set("stp", $('.selectpicker.sp-desktop[name="InitialRental"]').val() + '/' + $('.selectpicker.sp-desktop[name="ContractTerm"]').val() + '/' + $('.selectpicker.sp-desktop[name="AnnualMileage"]').val(), 30);
                $('.js-options-loader').fadeOut();
            }
        });
}

function MadeJsonSafe(value) {
    value = value.replaceAll("\"", "&quot;");
    value = value.replaceAll("'", "\"");
    return value;
}
$(document).on('click', '.add-option', function (e) {
    e.preventDefault();

    if (hasSentEvent == false) {
        
        var cookieConsent = document.cookie.indexOf('cookieconsent_status');
        if(cookieConsent > 0) {
            var addOptionSentId = makeid(10);
            fbq('track', 'CustomizeProduct', {}, {eventID: addOptionSentId});
            $.ajax({
                url: '/umbraco/api/FacebookPixelAPI/TrackFacebookEvent',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    EventID: addOptionSentId,
                    RawEventName: 'CustomizeProduct'
                }),
                success: function (apiResponse) {
                }
            });
        }
        hasSentEvent = true;
    }

    var $this = $(this);
    var confirmChange = ConfirmOptionChange($this, true);
    if (confirmChange === "RETURN")
        return;
    var optionCode = confirmChange;

    $('.js-options-loader').fadeIn();
    var pricingType = $('.pt-cookie.is-active').html();
    if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "desktop") {
        var form = $("#vehicle-filter-form");
        $('#SelectedOptionsInput').val($('#SelectedOptionsInput').val() + " " + optionCode);
        $.ajax(
            {
                url: form.attr('action'),
                data: form.serialize(),
                type: "GET",
                success: function (data) {
                    DesktopMinimumPricingChanges(pricingType);
                    $("#pricing-result-no-fixed").html(data);
                    if ($(window).width() > 992) {
                        $('.detail__action-btns').appendTo('#fixed-pricing');
                        $('#pricing-result').addClass('stick-area');
                    }
                    RefreshDropdowns();
                    $('.js-vehicle-price').text($('#monthlyPayments').text());
                    $('.js-initial-price').text($('#initialPayment').text());
                    $('.p11d-figure').html("&pound;" + Number($('#p11dValueInput').val()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                    $this.removeClass('add-option').addClass('remove-option');
                    $this.html('<span class="icon-circle-with-cross"></span> Remove');
                    $this.blur();
                    updateOptions();
                    updateP11D();
                    $('.js-options-loader').fadeOut();
                }
            });
    }
    else if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "mobile") {
        var mobileForm = $("#vehicle-filter-form-mobile");
        $('#SelectedOptionsInputMobile').val($('#SelectedOptionsInputMobile').val() + " " + optionCode);
        $.ajax(
            {
                url: mobileForm.attr('action'),
                data: mobileForm.serialize(),
                type: "GET",
                success: function (data) {
                    DesktopMinimumPricingChanges(pricingType);
                    $("#pricing-result-mobile").html(data);
                    RefreshDropdowns();
                    $('.js-vehicle-price').text($('#monthlypaymentsMobile').text());
                    $('.js-initial-price').text($('#initialPaymentMobile').text());
                    $('.p11d-figure').html("&pound;" + Number($('#p11dValueInputMobile').val()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                    $this.removeClass('add-option').addClass('remove-option');
                    $this.html('<span class="icon-circle-with-cross"></span> Remove');
                    $this.blur();
                    updateOptionsMobile();
                    $('.js-options-loader').fadeOut();
                }
            });
    }
});

function addToOptionList(optionList, option) {
    var optionListVal = $(optionList).val();
    if (optionListVal.indexOf(option) === -1) {
        optionListVal = optionListVal + " " + option;
    }
    return optionListVal;
}
function removeFromOptionList(optionList, option) {
    var optionListVal = $(optionList).val();
    var stillInList = true;
    while (stillInList) {
        if (optionListVal.indexOf(option) !== -1) {
            optionListVal = optionListVal.replace(option, "");
        }

        if (optionListVal.indexOf(option) === -1) {
            stillInList = false;
        }
    }
    return optionListVal;
}

function ConfirmOptionChange($this, isAdd) {
    var optionCode = $this.data("option-code");
    var addOptionsCode = MadeJsonSafe($this.data("add-options"));
    var removeOptionsCode = MadeJsonSafe($this.data("remove-options"));
    var choiceOptions = MadeJsonSafe($this.data("choice-options"));
    var agreeChange = $this.data("agree-change");

    if ((addOptionsCode !== '' && addOptionsCode !== undefined)
        || (removeOptionsCode !== '' && removeOptionsCode !== undefined)
        || (choiceOptions !== '' && choiceOptions !== undefined)) {
        if (agreeChange === undefined || agreeChange === '') {
            $('.js-options-loader').fadeOut();
            var changeMessage = '';
            var disableChange = '';
            var addingOption = {
                option: '',
                cost: 0,
                vat: 0,
                total: 0
            };
            var add = '';
            var remove = '';
            var choices = '';

            if (addOptionsCode !== '' && addOptionsCode !== undefined) {
                add = JSON.parse(addOptionsCode);
            }
            if (removeOptionsCode !== '' && removeOptionsCode !== undefined) {
                remove = JSON.parse(removeOptionsCode);
            }
            if (choiceOptions !== '' && choiceOptions !== undefined) {
                choices = JSON.parse(choiceOptions);
            }
            if (addOptionsCode !== '' && addOptionsCode !== undefined) {
                addingOption.option = add.option;
                addingOption.cost = add.cost;
                addingOption.vat = add.vat;
                addingOption.total = add.total;
            }
            else if (removeOptionsCode !== '' && removeOptionsCode !== undefined) {
                addingOption.option = remove.option;
                addingOption.cost = remove.cost;
                addingOption.vat = remove.vat;
                addingOption.total = remove.total;
            }
            else if (choiceOptions !== '' && choiceOptions !== undefined) {
                addingOption.option = choices.option;
                addingOption.cost = choices.cost;
                addingOption.vat = choices.vat;
                addingOption.total = choices.total;
            }

            var totalChangeCost = 0;

            if (isAdd) {
                changeMessage = changeMessage + "Your chosen item:<br/><br/>";
            }
            else {
                changeMessage = changeMessage + "Removing this item:<br/><br/>";
            }
            changeMessage = changeMessage + "<div class=\"pseudo-table vehicle-options-table\">";
            changeMessage = changeMessage + "   <div class=\"pseudo-thead clearfix\">";
            changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4\">&nbsp;</div>";
            changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-12 col-md-12 col-lg-12 vehicle-options-description-mobile\"><p>Description</p></div>";
            changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4 u-textCentre\">";
            changeMessage = changeMessage + "           <div class=\"pseudo-td-align-center\"><p>List Price</p></div>";
            changeMessage = changeMessage + "       </div>";
            changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4 u-textCentre\">";
            changeMessage = changeMessage + "           <div class=\"pseudo-td-align-center\"><p>Monthly</p></div>";
            changeMessage = changeMessage + "       </div>";
            changeMessage = changeMessage + "   </div>";
            changeMessage = changeMessage + "   <div class=\"pseudo-tr\">";
            changeMessage = changeMessage + "       <div class=\"detail__options__tab-inner-content\">";
            if (isAdd) {
                changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td u-textCentre\">";
                changeMessage = changeMessage + "                 <div class=\"pseudo-td-align-center\"><p> <a class=\"select-option btn btn-filter btn-filter-mobile btn-with-icon btn-xs disabled\"><span class=\"icon-circle-with-plus\"></span>Add</a></p></div>";
                changeMessage = changeMessage + "           </div>";
            }
            else {
                changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td vehicle-option-name vehicle-option-price vehicle-option-price-mobile\">";
                changeMessage = changeMessage + "               <div class=\"pseudo-td-align-center\"><p> <a class=\"remove-option btn btn-filter btn-filter-mobile btn-with-icon btn-xs disabled\"><span class=\"icon-circle-with-cross\"></span>Remove</a></p></div>";
                changeMessage = changeMessage + "           </div>";
            }
            changeMessage = changeMessage + "           <div class=\"col-xs-12 col-md-12 col-lg-12 pseudo-td vehicle-option-name vehicle-option-name-mobile\"><p>" + addingOption.option + "</p></div>";
            changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td vehicle-option-name vehicle-option-price vehicle-option-price-list-mobile\">";
            changeMessage = changeMessage + "               <div class=\"pseudo-td-align-center\"><p class=\"u-textCentre\">&pound;" + addingOption.cost + "<br/><span class=\"u-gray u-fontSizeSmall u-vat\">" + (addingOption.vat == "1" ? "+VAT" : "inc VAT") + "</span></p></div>";
            changeMessage = changeMessage + "           </div>";
            changeMessage = changeMessage + "           <div class=\"col-xs-4    col-md-4 col-lg-4 pseudo-td vehicle-option-name vehicle-option-price\">";
            changeMessage = changeMessage + "               <div class=\"pseudo-td-align-center\"><p class=\"u-textCentre\">&pound;" + addingOption.total + "<br/><span class=\"u-gray u-fontSizeSmall u-vat\">" + (addingOption.vat == "1" ? "+VAT" : "inc VAT") + "</span></p></div>";
            changeMessage = changeMessage + "           </div>";
            changeMessage = changeMessage + "       </div>";
            changeMessage = changeMessage + "   </div>";
            changeMessage = changeMessage + "</div>";

            if (addOptionsCode !== '' && addOptionsCode !== undefined) {
                changeMessage = changeMessage + "<br/><br/>Must be combined with additional equipment:<br/><br/>";
                changeMessage = changeMessage + "<div class=\"pseudo-table vehicle-options-table\">";
                changeMessage = changeMessage + "   <div class=\"pseudo-thead clearfix\">";
                changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4\">&nbsp;</div>";
                changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-12 col-md-12 col-lg-12 vehicle-options-description-mobile\"><p>Description</p></div>";
                changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4 u-textCentre\">";
                changeMessage = changeMessage + "           <div class=\"pseudo-td-align-center\"><p>List Price</p></div>";
                changeMessage = changeMessage + "       </div>";
                changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4 u-textCentre\">";
                changeMessage = changeMessage + "           <div class=\"pseudo-td-align-center\"><p>Monthly</p></div>";
                changeMessage = changeMessage + "       </div>";
                changeMessage = changeMessage + "   </div>";
                for (i in add.add) {
                    changeMessage = changeMessage + "   <div class=\"pseudo-tr\">";
                    changeMessage = changeMessage + "       <div class=\"detail__options__tab-inner-content\">";
                    changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td vehicle-option-name vehicle-option-price vehicle-option-price-mobile\">";
                    changeMessage = changeMessage + "                      <div class=\"pseudo-td-align-center\"><p> <a class=\"select-option btn btn-filter btn-filter-mobile btn-with-icon btn-xs disabled\"><span class=\"icon-circle-with-plus\"></span>Add</a></p></div>";
                    changeMessage = changeMessage + "           </div>";
                    changeMessage = changeMessage + "           <div class=\"col-xs-12 col-md-12 col-lg-12 pseudo-td vehicle-option-name vehicle-option-name-mobile\"><p>" + add.add[i].name + "</p></div>";
                    changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td vehicle-option-name vehicle-option-price vehicle-option-price-list-mobile\">";
                    changeMessage = changeMessage + "               <div class=\"pseudo-td-align-center\"><p class=\"u-textCentre\">&pound;" + add.add[i].cost + "<br/><span class=\"u-gray u-fontSizeSmall u-vat\">" + (add.add[i].vat == "1" ? "+VAT" : "inc VAT") + "</span></p></div>";
                    changeMessage = changeMessage + "           </div>";
                    changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td vehicle-option-name vehicle-option-price\">";
                    changeMessage = changeMessage + "               <div class=\"pseudo-td-align-center\"><p class=\"u-textCentre\">&pound;" + add.add[i].total + "<br/><span class=\"u-gray u-fontSizeSmall u-vat\">" + (add.add[i].vat == "1" ? "+VAT" : "inc VAT") + "</span></p></div>";
                    changeMessage = changeMessage + "           </div>";
                    changeMessage = changeMessage + "       </div>";
                    changeMessage = changeMessage + "   </div>";
                }
            }
            if (removeOptionsCode !== '' && removeOptionsCode !== undefined) {
                if (addOptionsCode === '' || addOptionsCode === undefined) {
                    changeMessage = changeMessage + "<br/><br/>Must be combined with additional equipment:<br/><br/>";
                    changeMessage = changeMessage + "<div class=\"pseudo-table vehicle-options-table\">";
                    changeMessage = changeMessage + "   <div class=\"pseudo-thead clearfix\">";
                    changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4\">&nbsp;</div>";
                    changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-12 col-md-12 col-lg-12 vehicle-options-description-mobile\"><p>Description</p></div>";
                    changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4 u-textCentre\">";
                    changeMessage = changeMessage + "           <div class=\"pseudo-td-align-center\"><p>List Price</p></div>";
                    changeMessage = changeMessage + "       </div>";
                    changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4 u-textCentre\">";
                    changeMessage = changeMessage + "           <div class=\"pseudo-td-align-center\"><p>Monthly</p></div>";
                    changeMessage = changeMessage + "       </div>";
                    changeMessage = changeMessage + "   </div>";
                }
                for (i in remove.remove) {
                    changeMessage = changeMessage + "   <div class=\"pseudo-tr\">";
                    changeMessage = changeMessage + "       <div class=\"detail__options__tab-inner-content\">";
                    changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td vehicle-option-name vehicle-option-price vehicle-option-price-mobile\">";
                    changeMessage = changeMessage + "                   <div class=\"pseudo-td-align-center\"><p> <a class=\"remove-option btn btn-filter btn-filter-mobile btn-with-icon btn-xs disabled\"><span class=\"icon-circle-with-cross\"></span>Remove</a></p></div>";
                    changeMessage = changeMessage + "           </div>";
                    changeMessage = changeMessage + "           <div class=\"col-xs-12 col-md-12 col-lg-12 pseudo-td vehicle-option-name vehicle-option-name-mobile\"><p>" + remove.remove[i].name + "</p></div>";
                    changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td vehicle-option-name vehicle-option-price vehicle-option-price-list-mobile\">";
                    changeMessage = changeMessage + "               <div class=\"pseudo-td-align-center\"><p class=\"u-textCentre\" style=\"color: red;\">- &pound;" + remove.remove[i].cost + "<br/><span class=\"u-gray u-fontSizeSmall u-vat\">" + (remove.remove[i].vat == "1" ? "+VAT" : "inc VAT") + "</span></p></div>";
                    changeMessage = changeMessage + "           </div>";
                    changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td vehicle-option-name vehicle-option-price\">";
                    changeMessage = changeMessage + "               <div class=\"pseudo-td-align-center\"><p class=\"u-textCentre\" style=\"color: red;\">- &pound;" + remove.remove[i].total + "<br/><span class=\"u-gray u-fontSizeSmall u-vat\">" + (remove.remove[i].vat == "1" ? "+VAT" : "inc VAT") + "</span></p></div>";
                    changeMessage = changeMessage + "           </div>";
                    changeMessage = changeMessage + "       </div>";
                    changeMessage = changeMessage + "   </div>";
                }
            }
            if ((addOptionsCode !== '' && addOptionsCode !== undefined)
                || (removeOptionsCode !== '' && removeOptionsCode !== undefined)) {
                changeMessage = changeMessage + "</div>";
            }
            if (choiceOptions !== '' && choiceOptions !== undefined) {
                changeMessage = changeMessage + "<br/><br/>To select this option, please choose one of the following:<br/><br/>";
                changeMessage = changeMessage + "<div class=\"pseudo-table vehicle-options-table\">";
                changeMessage = changeMessage + "   <div class=\"pseudo-thead clearfix\">";
                changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4\">&nbsp;</div>";
                changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-12 col-md-12 col-lg-12 vehicle-options-description-mobile\"><p>Description</p></div>";
                changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4 u-textCentre\">";
                changeMessage = changeMessage + "           <div class=\"pseudo-td-align-center\"><p>List Price</p></div>";
                changeMessage = changeMessage + "       </div>";
                changeMessage = changeMessage + "       <div class=\"pseudo-th col-xs-4 col-md-4 col-lg-4 u-textCentre\">";
                changeMessage = changeMessage + "           <div class=\"pseudo-td-align-center\"><p>Monthly</p></div>";
                changeMessage = changeMessage + "       </div>";
                changeMessage = changeMessage + "   </div>";
                for (i in choices.choices) {
                    var removeChoiceIds = '';
                    for (j in choices.choices) {
                        if (choices.choices[i].id !== choices.choices[j].id) {
                            if (removeChoiceIds !== '') {
                                removeChoiceIds = removeChoiceIds + ",";
                            }
                            removeChoiceIds = removeChoiceIds + choices.choices[j].id;
                        }
                    }
                    var addOthers = '';
                    for (k in choices.choices[i].addothers) {
                        if (addOthers !== '') {
                            addOthers = addOthers + ",";
                        }
                        addOthers = addOthers + choices.choices[i].addothers[k].id;
                    }
                    var removeOthers = '';
                    for (k in choices.choices[i].removeothers) {
                        if (removeOthers !== '') {
                            removeOthers = removeOthers + ",";
                        }
                        removeOthers = removeOthers + choices.choices[i].removeothers[k].id;
                    }
                    changeMessage = changeMessage + "   <div class=\"pseudo-tr\">";
                    changeMessage = changeMessage + "       <div class=\"detail__options__tab-inner-content\">";
                    changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td u-textCentre\">";
                    changeMessage = changeMessage + "               <div class=\"pseudo-td-align-center\"><p><a href=\"#\" data-option-code=\"" + choices.choices[i].id + "\" data-option-choiceremove=\"" + removeChoiceIds + "\" data-option-addother=\"" + addOthers + "\" data-option-removeother=\"" + removeOthers + "\" class=\"select-option btn btn-filter btn-filter-mobile btn-with-icon btn-xs\"><span class=\"icon-circle-with-plus\"></span>Add</a></p></div>";
                    changeMessage = changeMessage + "           </div>";
                    changeMessage = changeMessage + "           <div class=\"col-xs-12 col-md-12 col-lg-12 pseudo-td vehicle-option-name vehicle-option-name-mobile\"><p>" + choices.choices[i].name + "</p></div>";
                    changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td vehicle-option-name vehicle-option-price vehicle-option-price-list-mobile\">";
                    changeMessage = changeMessage + "               <div class=\"pseudo-td-align-center\"><p class=\"u-textCentre\">&pound;" + choices.choices[i].cost + "<br/><span class=\"u-gray u-fontSizeSmall u-vat\">" + (choices.choices[i].vat == "1" ? "+VAT" : "inc VAT") + "</span></p></div>";
                    changeMessage = changeMessage + "           </div>";
                    changeMessage = changeMessage + "           <div class=\"col-xs-4 col-md-4 col-lg-4 pseudo-td vehicle-option-name vehicle-option-price\">";
                    changeMessage = changeMessage + "               <div class=\"pseudo-td-align-center\"><p class=\"u-textCentre\">&pound;" + choices.choices[i].total + "<br/><span class=\"u-gray u-fontSizeSmall u-vat\">" + (choices.choices[i].vat == "1" ? "+VAT" : "inc VAT") + "</span></p></div>";
                    changeMessage = changeMessage + "           </div>";
                    changeMessage = changeMessage + "       </div>";
                    changeMessage = changeMessage + "   </div>";
                }
                changeMessage = changeMessage + "</div>";
                disableChange = 'disabled';
            }

            changeMessage = changeMessage + "<br/><br/><div class=\"pseudo-table vehicle-options-table\">";
            changeMessage = changeMessage + "   <div class=\"pseudo-tr\">";
            changeMessage = changeMessage + "       <div class=\"pseudo-td col-xs-12 col-md-12 col-lg-12\"><a href=\"#\" class=\"btn btn-primary btn-block u-gutter cancel-change\">Cancel</a></div>";
            if (isAdd) {
                changeMessage = changeMessage + "       <div class=\"pseudo-td col-xs-12 col-md-12 col-lg-12\"><a href=\"#\" class=\"btn btn-primary btn-block u-gutter agree-change " + disableChange + "\">Add to vehicle</a></div>";
            }
            else {
                changeMessage = changeMessage + "       <div class=\"pseudo-td col-xs-12 col-md-12 col-lg-12\"><a href=\"#\" class=\"btn btn-primary btn-block u-gutter agree-change " + disableChange + "\">Remove</a></div>";
            }
            changeMessage = changeMessage + "   </div>";
            changeMessage = changeMessage + "</div>";

            $.magnificPopup.open({
                items: {
                    src: '<div class="white-popup">' + changeMessage + '</div>',
                    type: 'inline'
                }
            });

            setTimeout(function () {
                if (choiceOptions !== '' && choiceOptions !== undefined) {
                    $('.select-option').off("click").on("click", function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        var selectedOption = $(this).data("option-code");
                        var choiceRemoveOptions = $(this).data("option-choiceremove");
                        var addOtherOptions = $(this).data("option-addother");
                        var removeOtherOptions = $(this).data("option-removeother");
                        $this.data("selectedChoiceOption", selectedOption);
                        $this.data("removeChoiceOption", choiceRemoveOptions);
                        $this.data("addOtherChoice", addOtherOptions);
                        $this.data("removeOtherChoice", removeOtherOptions);
                        $('.agree-change').removeClass("disabled");
                        $('.select-option').each(function () {
                            $(this)[0].innerHTML = "<span class=\"icon-circle-with-plus\"></span>Add";
                            $(this).removeClass("remove-option remove-option-alt");
                        });
                        $(this).addClass("remove-option remove-option-alt");
                        $(this)[0].innerHTML = "<span class=\"icon-circle-with-cross\"></span>Add";
                        $('.agree-change').focus();
                    });
                }
                $('.agree-change').off("click").on("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $this.data("agree-change", "yes");
                    $this.click();
                    $.magnificPopup.close();
                });
                $('.cancel-change').off("click").on("click", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $this.data("agree-change", "no");
                    $this.click();
                    $.magnificPopup.close();
                });
            }, 500);

            return "RETURN";
        }
        else if (agreeChange === "yes") {
            var removeAgree;
            var addAgree;
            var choiceRemoveOptions;
            var choiceRemoveOptionsSplit;
            var addOtherChoiceSplit;
            var addOtherChoice;
            var removeOtherChoiceSplit;
            var removeOtherChoice;
            if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "desktop") {
                if (choiceOptions !== '' && choiceOptions !== undefined) {
                    $('#SelectedOptionsInput').val(addToOptionList($('#SelectedOptionsInput'), $this.data("selectedChoiceOption")));
                    choiceRemoveOptions = $this.data("removeChoiceOption");
                    if (choiceRemoveOptions !== '' && choiceRemoveOptions !== undefined) {
                        choiceRemoveOptionsSplit = choiceRemoveOptions.toString().split(',');
                        for (rem in choiceRemoveOptionsSplit) {
                            $('#SelectedOptionsInput').val(removeFromOptionList($('#SelectedOptionsInput'), choiceRemoveOptionsSplit[rem]));
                        }
                    }
                    addOtherChoice = $this.data("addOtherChoice");
                    if (addOtherChoice !== '' && addOtherChoice !== undefined) {
                        addOtherChoiceSplit = addOtherChoice.toString().split(',');
                        for (add in addOtherChoiceSplit) {
                            $('#SelectedOptionsInput').val(addToOptionList($('#SelectedOptionsInput'), addOtherChoiceSplit[add]));
                        }
                    }
                    removeOtherChoice = $this.data("removeOtherChoice");
                    if (removeOtherChoice !== '' && removeOtherChoice !== undefined) {
                        removeOtherChoiceSplit = removeOtherChoice.toString().split(',');
                        for (rem in removeOtherChoiceSplit) {
                            $('#SelectedOptionsInput').val(removeFromOptionList($('#SelectedOptionsInput'), removeOtherChoiceSplit[rem]));
                        }
                    }
                }
                if (addOptionsCode !== '' && addOptionsCode !== undefined) {
                    addAgree = JSON.parse(addOptionsCode);
                    for (i in addAgree.add) {
                        $('#SelectedOptionsInput').val(addToOptionList($('#SelectedOptionsInput'), addAgree.add[i].id));
                    }
                }
                if (removeOptionsCode !== '' && removeOptionsCode !== undefined) {
                    removeAgree = JSON.parse(removeOptionsCode);
                    for (i in removeAgree.remove) {
                        $('#SelectedOptionsInput').val(removeFromOptionList($('#SelectedOptionsInput'), removeAgree.remove[i].id));
                    }
                }
            }
            else if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "mobile") {
                if (choiceOptions !== '' && choiceOptions !== undefined) {
                    $('#SelectedOptionsInputMobile').val(addToOptionList($('#SelectedOptionsInputMobile'), $this.data("selectedChoiceOption")));
                    choiceRemoveOptions = $this.data("removeChoiceOption");
                    if (choiceRemoveOptions !== '' && choiceRemoveOptions !== undefined) {
                        choiceRemoveOptionsSplit = choiceRemoveOptions.toString().split(',');
                        for (rem in choiceRemoveOptionsSplit) {
                            $('#SelectedOptionsInputMobile').val(removeFromOptionList($('#SelectedOptionsInputMobile'), choiceRemoveOptionsSplit[rem]));
                        }
                    }
                    addOtherChoice = $this.data("addOtherChoice");
                    if (addOtherChoice !== '' && addOtherChoice !== undefined) {
                        addOtherChoiceSplit = addOtherChoice.toString().split(',');
                        for (add in addOtherChoiceSplit) {
                            $('#SelectedOptionsInputMobile').val(addToOptionList($('#SelectedOptionsInputMobile'), addOtherChoiceSplit[add]));
                        }
                    }
                    removeOtherChoice = $this.data("removeOtherChoice");
                    if (removeOtherChoice !== '' && removeOtherChoice !== undefined) {
                        removeOtherChoiceSplit = removeOtherChoice.toString().split(',');
                        for (rem in removeOtherChoiceSplit) {
                            $('#SelectedOptionsInputMobile').val(removeFromOptionList($('#SelectedOptionsInputMobile'), removeOtherChoiceSplit[rem]));
                        }
                    }
                }
                if (addOptionsCode !== '' && addOptionsCode !== undefined) {
                    addAgree = JSON.parse(addOptionsCode);
                    for (i in addAgree.add) {
                        $('#SelectedOptionsInputMobile').val(addToOptionList($('#SelectedOptionsInputMobile'), addAgree.add[i].id));
                    }
                }
                if (removeOptionsCode !== '' && removeOptionsCode !== undefined) {
                    removeAgree = JSON.parse(removeOptionsCode);
                    for (i in removeAgree.remove) {
                        $('#SelectedOptionsInputMobile').val(removeFromOptionList($('#SelectedOptionsInputMobile'), removeAgree.remove[i].id));
                    }
                }
            }
        }
        else if (agreeChange === "no") {
            optionCode = "RETURN";
            $this.data("agree-change", "");
        }
    }
    return optionCode;
}

$(document).on('click', '.remove-option', function (e) {
    e.preventDefault();

    var $this = $(this);
    var confirmChange = ConfirmOptionChange($this, false);
    if (confirmChange === "RETURN")
        return;
    var optionCode = confirmChange;

    $('.js-options-loader').fadeIn();
    if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "desktop") {
        var form = $("#vehicle-filter-form");
        $('#SelectedOptionsInput').val($('#SelectedOptionsInput').val().replace(" " + optionCode, ""));
        var pricingType = $('.pt-cookie.is-active').html();
        $.ajax(
            {
                url: form.attr('action'),
                data: form.serialize(),
                type: "GET",
                success: function (data) {
                    DesktopMinimumPricingChanges(pricingType);
                    $("#pricing-result-no-fixed").html(data);
                    if ($(window).width() > 992) {
                        $('.detail__action-btns').appendTo('#fixed-pricing');
                        $('#pricing-result').addClass('stick-area');
                    }
                    RefreshDropdowns();
                    $('.js-vehicle-price').text($('#monthlyPayments').text());
                    $('.js-initial-price').text($('#initialPayment').text());
                    $('.p11d-figure').html("&pound;" + Number($('#p11dValueInput').val()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                    $('a[data-option-code="' + optionCode + '"]').removeClass('remove-option').addClass('add-option');
                    $('a[data-option-code="' + optionCode + '"]').html('<span class="icon-circle-with-plus"></span> Add');
                    $this.blur();
                    updateOptions();
                    updateP11D();
                    $('.js-options-loader').fadeOut();
                }
            });
    } else if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "mobile") {
        var mobileForm = $("#vehicle-filter-form-mobile");
        $('#SelectedOptionsInputMobile').val($('#SelectedOptionsInputMobile').val().replace(" " + optionCode, ""));
        var mobilePricingType = $('.pt-cookie.is-active').html();
        $.ajax(
            {
                url: mobileForm.attr('action'),
                data: mobileForm.serialize(),
                type: "GET",
                success: function (data) {
                    DesktopMinimumPricingChanges(mobilePricingType);
                    $("#pricing-result-mobile").html(data);
                    RefreshDropdowns();
                    $('.js-vehicle-price').text($('#monthlypaymentsMobile').text());
                    $('.js-initial-price').text($('#initialPaymentMobile').text());
                    $('a[data-option-code="' + optionCode + '"]').removeClass('remove-option').addClass('add-option');
                    $('a[data-option-code="' + optionCode + '"]').html('<span class="icon-circle-with-plus"></span> Add');
                    $('.p11d-figure').html("&pound;" + Number($('#p11dValueInputMobile').val()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                    $this.blur();
                    updateOptionsMobile();
                    $('.js-options-loader').fadeOut();
                }
            });
    }
});

$(document).on('click', '.js-remove-all-options', function (e) {
    e.preventDefault();

    $('.js-options-loader').fadeIn();
    $('input[name="SelectedOptions"]').val("");

    var form = $("#vehicle-filter-form");
    var pricingType = $('.pt-cookie.is-active').html();
    $.ajax(
        {
            url: form.attr('action'),
            data: form.serialize(),
            type: "GET",
            success: function (data) {
                DesktopMinimumPricingChanges(pricingType);
                $("#pricing-result-no-fixed").html(data);
                if ($(window).width() > 992) {
                    $('.detail__action-btns').appendTo('#fixed-pricing');
                    $('#pricing-result').addClass('stick-area');
                }
                RefreshDropdowns();
                $('.js-vehicle-price').text($('#monthlyPayments').text());
                $('.js-initial-price').text($('#initialPayment').text());
                $('a[data-option-code]').removeClass('remove-option').addClass('add-option');
                $('a[data-option-code]').html('<span class="icon-circle-with-plus"></span> Add');
                updateOptions();
                updateP11D();
                $('.p11d-figure').html("&pound;" + Number($('#p11dValueInput').val()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                $('.js-options-loader').fadeOut();
            }
        });
});

function updatePricesMobile() {
    if (hasSentEvent == false) {
        var cookieConsent = document.cookie.indexOf('cookieconsent_status');
        if(cookieConsent > 0) {
            var updatepricesMobileEventId = makeid(10);
            fbq('track', 'CustomizeProduct', {}, {eventID: updatepricesMobileEventId});
            $.ajax({
                url: '/umbraco/api/FacebookPixelAPI/TrackFacebookEvent',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    EventID: updatepricesMobileEventId,
                    RawEventName: 'CustomizeProduct'
                }),
                success: function (apiResponse) {
                }
            });
        }
        hasSentEvent = true;
    }
    $('.js-options-loader').fadeIn();
    var form = $("#vehicle-filter-form-mobile");
    var pricingType = $('input[name="contract_type_mobile"]:checked').val();
    $.ajax(
        {
            url: form.attr('action'),
            data: form.serialize() + "&PricingType=" + pricingType,
            type: "GET",
            success: function (data) {
                DesktopMinimumPricingChanges(pricingType);
                $("#pricing-result-mobile").html(data);
                updateOptionsMobile();
                RefreshDropdowns();
                $('.js-vehicle-price').text($('#monthlypaymentsMobile').text());
                $('.js-initial-price').text($('#initialPaymentMobile').text());
                $('.u-vat').text($('.vat-display-change.text-smaller:first').text());
                $('.vat-display-change').text($('.vat-display-change.text-smaller-mobile:first').text());
                cookies.set("stp", $('.selectpicker.sp-mobile[name="InitialRental"]').val() + '/' + $('.selectpicker.sp-mobile[name="ContractTerm"]').val() + '/' + $('.selectpicker.sp-mobile[name="AnnualMileage"]').val(), 30);
                $('.js-options-loader').fadeOut();
            }
        });
}

$(document).on('click', '.removeall-mobile', function (e) {
    e.preventDefault();
    $('.js-options-loader').fadeIn();
    $('input[name="SelectedOptions"]').val("");

    var form = $("#vehicle-filter-form-mobile");
    var pricingType = $('.pt-cookie.is-active').html();
    $.ajax(
        {
            url: form.attr('action'),
            data: form.serialize(),
            type: "GET",
            success: function (data) {
                DesktopMinimumPricingChanges(pricingType);
                $("#pricing-result-mobile").html(data);
                RefreshDropdowns();
                $('.js-vehicle-price').text($('#monthlypaymentsMobile').text());
                $('.js-initial-price').text($('#initialPaymentMobile').text());
                $('a[data-option-code]').removeClass('remove-option').addClass('add-option');
                $('a[data-option-code]').html('<span class="icon-circle-with-plus"></span> Add');
                updateOptionsMobile();
                $('.p11d-figure').html("&pound;" + Number($('#p11dValueInputMobile').val()).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                $('.js-options-loader').fadeOut();
            }
        });
});

function showHideFixedQuoteBtn() {
    if ($('.detail__action-btns__mobile').length > 0) {
        var topPos = $('.detail__action-btns__mobile').get(0).getBoundingClientRect().top;

        if (Modernizr.mq('(max-width: 767px)')) {
            if (topPos < parseInt($(window).height() + 25) && topPos > 70) {
                $('.fixed-get-a-quote-btn').fadeOut();
                $('#back-top-to-link').addClass('show');
            }
            else {
                $('.fixed-get-a-quote-btn').fadeIn();
                $('#back-top-to-link').removeClass('show');
            }
        }
    }

}

function toggleOptionsMobile() {
    $('.detail__options__mobile-trigger').toggleClass('active');
    $('.detail__options').slideToggle();
}

function updateP11D() {
    $.ajax({
        type: "GET",
        url: '/api/p11dapi/getp11ddetails/?type=' + $('#vehicle-tax-details').data('type') +
            '&capid=' + $('#vehicle_detail_page').data('capid') +
            '&co2=' + $('#vehicle-tax-details').data("co2") +
            '&capfueltype=' + $('#vehicle-tax-details').data("capfueltype") +
            '&fueltype=' + $('#vehicle-tax-details').data("fueltype") +
            '&p11dvalue=' + $('#vehicle-tax-details').data("p11dvalue") +
            '&p11d=' + $('#vehicle-tax-details').data("p11d") +
            '&selectedOptions=' + $('#SelectedOptionsInput').val().trim() +
            '&ctype=' + $('#dropdownPricingType').val() +
            '&rent=' + $('#dropdownInitialRental').val() +
            '&cterm=' + $('#dropdownContractTerm').val() +
            '&mile=' + $('#dropdownAnnualMileage').val() +
            '&main=' + $('#vehicle-tax-details').data("main"),
        async: false,
        success: function (data) {
            $('#p11d-data').html(data);
        }
    });
}

function updateOptions() {
    if ($('#hidden-options-details').length === 0) {
        $.ajax({
            type: "GET",
            url: '/api/vehicleoptionsapi/getvehicleoptions/?capid=' 
                + $('#vehicle_detail_page').data('capid') 
                + '&contractTerm=' + $('#dropdownContractTerm').val()
                + '&initialRental=' + $('#dropdownInitialRental').val() 
                + '&pricingType=' + $('#dropdownPricingType').val() 
                + '&active=' + $('.col-xs-24.pseudo-th.accordian-rows.active').find('a').data('trigger-panel')
                + '&selectedOptions=' + $('#SelectedOptionsInput').val()
                + '&fuelType=' + $('#fuelType').val()
            ,
            async: false,
            success: function (data) {
                $('#options').html(data);
                var minValue = Number($('#minExpensiveCarSupplementValue').val());
                if (Number($('#p11dValueInput').val()) >= minValue && Number($('#p11dValueInitialInput').val()) < minValue) {
                    $('.p11d-limit').fadeIn();
                } else {
                    $('.p11d-limit').fadeOut();
                }
            }
        });
    }
}

function updateOptionsMobile() {
    if ($('#hidden-options-details').length === 0) {
        $.ajax({
            type: "GET",
            url: '/api/vehicleoptionsapi/getvehicleoptions/?capid='
                + $('#vehicle_detail_page').data('capid') 
                + '&contractTerm=' + $('.sp-mobile.contract-term').val() 
                + '&initialRental=' + $('.sp-mobile.initial-payment').val() 
                + '&pricingType=' + $('#dropdownPricingType').val() 
                + '&active=' + $('.col-xs-24.pseudo-th.accordian-rows.active').find('a').data('trigger-panel')
                + '&selectedOptions=' + $('#SelectedOptionsInputMobile').val()
                + '&fuelType=' + $('#fuelType').val()
            ,
            async: false,
            success: function (data) {
                $('#options-mobile').html(data);
                var minValue = Number($('#minExpensiveCarSupplementValueMobile').val());
                if (Number($('#p11dValueInputMobile').val()) >= minValue && Number($('#p11dValueInitialInputMobile').val()) < minValue) {
                    $('.p11d-limit').show();
                } else {
                    $('.p11d-limit').hide();
                }
            }
        });
    }
}

$(function () {

    if ($('#vehicle_detail_page').data('range') === "True") {
        cookies.set("vt", "Cars", 30);
    } else {
        cookies.set("vt", "Vans", 30);
    }

    $(document).on('click', '.pt-cookie', updatePricesFromTopBar);

    $(document).on('change', '.selectpicker.sp-desktop', updatePrices);

    $(document).on('click', '.js-contract-type-radios input:radio', updatePricesMobile);

    $(document).on('change', '.selectpicker.sp-mobile.payment-options', updatePricesMobile);

    $(document).on('click', '.contract_type_mobile', updatePricesMobile);

    $(document).on('submit', 'form[name="vehicle-payment"]', function (e) {
        e.preventDefault();
        var form = $('form[name="vehicle-payment"]:visible');
        var submit = form.find('button[type="submit"]');
        var currentText;

        if (submit.length) {
            currentText = submit.text();
            submit.text("Submitting...");
        } else {
            submit = form.find("input[type='submit']");
            currentText = submit.text();
            submit.val("Submitting...");
        }
        submit.attr("disabled", true);

        $.ajax({
            type: "POST",
            url: form.prop('action'),
            data: form.serializeArray(),
            success: function (data) {
                if (data.SaveSuccessful) {
                    var leadId = makeid(10);
                    var cookieConsent = document.cookie.indexOf('cookieconsent_status');
                    if(cookieConsent > 0) {
                        fbq('track', 'Lead', {}, {eventID: leadId});
                        $.ajax({
                            url: '/umbraco/api/FacebookPixelAPI/TrackFacebookEvent',
                            type: 'POST',
                            contentType: 'application/json',
                            data: JSON.stringify({
                                EventID: leadId,
                                RawEventName: 'Lead'
                            }),
                            success: function (apiResponse) {
                            }
                        });
                    }
                    
                    submit.removeAttr("disabled");
                    if (submit.is("input")) {
                        submit.val(currentText);
                    } else {
                        submit.text(currentText);
                    }
                    form.find('.response-holder').html('<p class="alert alert-success" style="display: block;"><span class="icon_holder"><i class="icon-ok-sign"></i>' + data.SubmissionText + '</span></p>');
                    $('#request-a-quote-details').hide();
                    $('.row.fixed-pricing__ctas').hide();
                    setTimeout(function () {
                        window.location = $('#form-request-info-popup:visible').data('completeurl') + "?info-request-model";
                    }, 500);
                } else {
                    form.find('.response-holder').html('<p class="alert alert-danger" style="display: block;"><span class="icon_holder"><i class="icon-warning-sign"></i> There was an issue submitting your details. Please try again.</span></p>');
                    submit.removeAttr("disabled");
                    if (submit.is("input")) {
                        submit.val(currentText);
                    } else {
                        submit.text(currentText);
                    }
                }
            },
            error: function () {
                submit.removeAttr("disabled");
                if (submit.is("input")) {
                    submit.val(currentText);
                } else {
                    submit.text(currentText);
                }
            }
        });
    });

    $(document).on('submit', 'form[name="get-quote"]', function (e) {
        e.preventDefault();
        var form = $('form[name="get-quote"]:visible');
        var submit = form.find('button[type="submit"]');
        var currentText;

        if (submit.length) {
            currentText = submit.text();
            submit.text("Submitting...");
        } else {
            submit = form.find("input[type='submit']");
            currentText = submit.text();
            submit.val("Submitting...");
        }
        submit.attr("disabled", true);
        $.ajax({
            type: "POST",
            url: form.prop('action'),
            data: form.serializeArray(),
            success: function (data) {
                submit.removeAttr("disabled");
                if (submit.is("input")) {
                    submit.val(currentText);
                } else {
                    submit.text(currentText);
                }
                if (data.SaveSuccessful) {
                    form.find('.response-holder').html('<p class="alert alert-success" style="display: block;"><span class="icon_holder"><i class="icon-ok-sign"></i>' + data.SubmissionText + '</span></p>');
                    $('#request-a-quote-details').hide();
                    $('.row.fixed-pricing__ctas').hide();
                    setTimeout(function () {
                        window.location = $('#form-request-info-popup:visible').data('completeurl');
                    }, 500);
                } else {
                    form.find('.response-holder').html('<p class="alert alert-danger" style="display: block;"><span class="icon_holder"><i class="icon-warning-sign"></i> There was an issue submitting your details. Please try again.</span></p>');
                    submit.removeAttr("disabled");
                    if (submit.is("input")) {
                        submit.val(currentText);
                    } else {
                        submit.text(currentText);
                    }
                }
            },
            error: function () {
                submit.removeAttr("disabled");
                if (submit.is("input")) {
                    submit.val(currentText);
                } else {
                    submit.text(currentText);
                }
            }
        });
    });

    $(document).on('click', '.js-open-confirm-popup', function (e) {
        e.preventDefault();

        var selectedOptions = "";
        var pricingType = "";
        var maint = "";
        if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "desktop") {
            selectedOptions = $('#SelectedOptionsInput').val();
            pricingType = $('.form-group:visible').find('.selectpicker[name="PricingType"]').val();
            maint = ($('.mileage-price:visible').length > 0 ? "TBC" : $('#maint').data('price') !== "0.00" ? $('#maint').data('price') : "");
        } else if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "mobile") {
            selectedOptions = $('#SelectedOptionsInputMobile').val();
            pricingType = $('input[name="contract_type_mobile"]:checked').val();
            maint = ($('.mileage-price:visible').length > 0 ? "TBC" : $('#maintmob').data('price') !== "0.00" ? $('#maintmob').data('price') : "");
        }

        var form = $('form[name="get-quote"]:visible');
        var popupUrl = '/forms/confirm-quote/';
        var virtualUrl = '/virtual/form-request/';

        var srcString = '';
        if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "desktop") {
            srcString = popupUrl + '?' + form.serialize() +
                "&vehicleType=" + $('#vehicle_detail_page').data('range') +
                "&vehicleSlug=" + window.location.pathname.split('?')[0] +
                "&capid=" + $('#vehicle_detail_page').data('capid') +
                "&vehicleName=" + $('#vehicle_detail_page').data('name') +
                "&pricingType=" + pricingType +
                "&contractTerm=" + $('.form-group:visible').find('.selectpicker[name="ContractTerm"]').val() +
                "&annualMileage=" + $('.form-group:visible').find('.selectpicker[name="AnnualMileage"]').val() +
                "&initialRental=" + $('.form-group:visible').find('.selectpicker[name="InitialRental"]').val() +
                "&maintenanceType=" + $('.form-group:visible').find('.selectpicker[name="MaintenanceType"]').val() +
                "&maintenanceCost=" + maint +
                "&price24=" + $('#price24').data('price') +
                "&price36=" + $('#price36').data('price') +
                "&price48=" + $('#price48').data('price') +
                "&price60=" + $('#price60').data('price') +
                "&funder24=" + $('#funder24').data('value') +
                "&funder36=" + $('#funder36').data('value') +
                "&funder48=" + $('#funder48').data('value') +
                "&vehicleOptions=" + selectedOptions;
        } else if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "mobile") {
            srcString = popupUrl + '?' + form.serialize() +
                "&vehicleType=" + $('#vehicle_detail_page').data('range') +
                "&vehicleSlug=" + window.location.pathname.split('?')[0] +
                "&capid=" + $('#vehicle_detail_page').data('capid') +
                "&vehicleName=" + $('#vehicle_detail_page').data('name') +
                "&pricingType=" + pricingType +
                "&contractTerm=" + $('.form-group:visible').find('.selectpicker[name="ContractTerm"]').val() +
                "&annualMileage=" + $('.form-group:visible').find('.selectpicker[name="AnnualMileage"]').val() +
                "&initialRental=" + $('.form-group:visible').find('.selectpicker[name="InitialRental"]').val() +
                "&maintenanceType=" + $('.form-group:visible').find('.selectpicker[name="MaintenanceType"]').val() +
                "&maintenanceCost=" + maint +
                "&price24=" + $('#price24mob').data('price') +
                "&price36=" + $('#price36mob').data('price') +
                "&price48=" + $('#price48mob').data('price') +
                "&price60=" + $('#price60mob').data('price') +
                "&funder24=" + $('#funder24mob').data('value') +
                "&funder36=" + $('#funder36mob').data('value') +
                "&funder48=" + $('#funder48mob').data('value') +
                "&vehicleOptions=" + selectedOptions;
        }

        $(this).magnificPopup({
            type: 'ajax',
            items: {
                src: srcString
            },
            mainClass: "mfp-zoom-out mfp-fixed-xs",
            focus: 'input:first',
            removalDelay: 400,
            closeOnBgClick: false,
            callbacks: {
                ajaxContentAdded: function () {
                    placeholderFallback();
                    $('.js-validate-check').each(function () {
                        validFormField($(this));
                    });
                    ga(function (tracker) {
                        var clientId = tracker.get('clientId');
                        $("#form_analytics_id").val(clientId);
                    });
                    ga('set', 'page', virtualUrl);
                    ga('send', 'pageview');
                    hj('vpv', '/virtual/form/');
                    $("#form_enquiry_type").val("quote");
                }
            }
        }).magnificPopup('open');
    });

    $(document).on('click', '.js-open-request-callback-popup', function (e) {
        e.preventDefault();

        var selectedOptions = "";
        var pricingType = "";
        var maint = "";
        if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "desktop") {
            selectedOptions = $('#SelectedOptionsInput').val();
            pricingType = $('.form-group:visible').find('.selectpicker[name="PricingType"]').val();
            maint = ($('.mileage-price:visible').length > 0 ? "TBC" : $('#maint').data('price') !== "0.00" ? $('#maint').data('price') : "");
        } else if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "mobile") {
            selectedOptions = $('#SelectedOptionsInputMobile').val();
            pricingType = $('input[name="contract_type_mobile"]:checked').val();
            maint = ($('.mileage-price:visible').length > 0 ? "TBC" : $('#maintmob').data('price') !== "0.00" ? $('#maintmob').data('price') : "");
        }

        var form = $('form[name="vehicle-payment"]:visible');
        var popupUrl = '/forms/request-information/';
        var virtualUrl = '/virtual/form-request/';

        var srcString = '';
        if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "desktop") {
            srcString = popupUrl + '?' + form.serialize() +
                "&vehicletype=" + $('#vehicle_detail_page').data('range') +
                "&capid=" + $('#vehicle_detail_page').data('capid') +
                "&vehiclename=" + $('#vehicle_detail_page').data('name') +
                "&pricingType=" + pricingType +
                "&contractTerm=" + $('.form-group:visible').find('.selectpicker[name="ContractTerm"]').val() +
                "&annualMileage=" + $('.form-group:visible').find('.selectpicker[name="AnnualMileage"]').val() +
                "&initialRental=" + $('.form-group:visible').find('.selectpicker[name="InitialRental"]').val() +
                "&maintenanceType=" + $('.form-group:visible').find('.selectpicker[name="MaintenanceType"]').val() +
                "&maintenanceCost=" + maint +
                "&price24=" + $('#price24').data('price') +
                "&price36=" + $('#price36').data('price') +
                "&price48=" + $('#price48').data('price') +
                "&price60=" + $('#price60').data('price') +
                "&funder24=" + $('#funder24').data('value') +
                "&funder36=" + $('#funder36').data('value') +
                "&funder48=" + $('#funder48').data('value') +
                "&vehicleOptions=" + selectedOptions;
        } else if ($('form[name="vehicle-payment"]:visible').find('input[name="FormType"]').val() === "mobile") {
            srcString = popupUrl + '?' + form.serialize() +
                "&vehicletype=" + $('#vehicle_detail_page').data('range') +
                "&capid=" + $('#vehicle_detail_page').data('capid') +
                "&vehiclename=" + $('#vehicle_detail_page').data('name') +
                "&pricingType=" + pricingType +
                "&contractTerm=" + $('.form-group:visible').find('.selectpicker[name="ContractTerm"]').val() +
                "&annualMileage=" + $('.form-group:visible').find('.selectpicker[name="AnnualMileage"]').val() +
                "&initialRental=" + $('.form-group:visible').find('.selectpicker[name="InitialRental"]').val() +
                "&maintenanceType=" + $('.form-group:visible').find('.selectpicker[name="MaintenanceType"]').val() +
                "&maintenanceCost=" + maint +
                "&price24=" + $('#price24mob').data('price') +
                "&price36=" + $('#price36mob').data('price') +
                "&price48=" + $('#price48mob').data('price') +
                "&price60=" + $('#price60mob').data('price') +
                "&funder24=" + $('#funder24mob').data('value') +
                "&funder36=" + $('#funder36mob').data('value') +
                "&funder48=" + $('#funder48mob').data('value') +
                "&vehicleOptions=" + selectedOptions;
        }

        $(this).magnificPopup({
            type: 'ajax',
            items: {
                src: srcString
            },
            mainClass: "mfp-zoom-out mfp-fixed-xs",
            focus: 'input:first',
            removalDelay: 400,
            closeOnBgClick: false,
            callbacks: {
                ajaxContentAdded: function () {
                    placeholderFallback();
                    $('.js-validate-check').each(function () {
                        validFormField($(this));
                    });

                    ga(function (tracker) {
                        var clientId = tracker.get('clientId');
                        $("#form_analytics_id").val(clientId);
                    });
                    ga('set', 'page', virtualUrl);
                    ga('send', 'pageview');
                    hj('vpv', '/virtual/form/');
                    $("#form_enquiry_type").val("callback");
                }
            }
        }).magnificPopup('open');
    });

    $('select.inc-maintenance-option').on('change', function (e) {
        e.preventDefault();

        var formGroup = $(this).parents('.form-group');
        var selectValue = $(this).val();

        if (selectValue === 1) {
            $('.inc-maintenance-option').find('.pseudo-checkbox').addClass('checked');
            $('.inc-maintenance-option').find('.checkbox-input').prop('checked', true);

            formGroup.addClass('mod-bordered');
            formGroup.find('.disclaimer').fadeIn();
        }
        else if (selectValue && $('.inc-maintenance-option').find('.checkbox-input').prop('checked')) {
            ('.inc-maintenance-option').find('.pseudo-checkbox').removeClass('checked');
            ('.inc-maintenance-option').find('.checkbox-input').prop('checked', false);
        }

        if (selectValue !== 1) {
            formGroup.removeClass('mod-bordered');
            formGroup.find('.disclaimer').fadeOut();
        }

        maintenanceMileageResponse();
    });

    $('select.js-mileage').on('change', function (e) {
        var mileage = $(this).val();
        var milageArray = $('#validMileage').data('mileagearray').split("|");
        var formGroup = $(this).parents('.form-group');

        window.site.trackEvent('get a quote', 'click', 'miles per year ' + mileage);

        if (milageArray.indexOf(mileage) === -1) {
            formGroup.addClass('mod-bordered');
            formGroup.find('.disclaimer').fadeIn();
            $('.confirm-quote-btn').removeClass('valid-mileage');
        }
        else {
            formGroup.removeClass('mod-bordered');
            formGroup.find('.disclaimer').fadeOut();
            $('.confirm-quote-btn').addClass('valid-mileage');
        }

        maintenanceMileageResponse();
    });

    $(document).on('click', '.js-open-confirm-popup', function (e) {
        window.site.trackEvent('open get a quote popup', 'click', 'confirm quote popup');
    });

    $(document).on('click', '.js-open-request-callback-popup', function (e) {
        window.site.trackEvent('open request callback popup', 'click', 'request callback popup');
    });

    $('select.contract-type').on('change', function (e) {
        window.site.trackEvent('get a quote', 'click', 'contract type', $(this).val());
    });

    $('select.contract-term').on('change', function (e) {
        window.site.trackEvent('get a quote', 'click', 'contract length', $(this).val());
    });

    $('select.initial-payment ').on('change', function (e) {
        window.site.trackEvent('get a quote', 'click', 'initial payment', $(this).val());
    });

    $('.js-inc-maintenance').on('change', function (e) {
        window.site.trackEvent('get a quote', 'click', 'include maintenance in contract');
    });

    $('.js-anchor-to-options').on('click', function (e) {
        window.site.trackEvent('get a quote', 'click', 'add vehicle options');
    });

    $('.fixed-get-a-quote-btn').on('click', 'a', function (e) {
        window.site.trackEvent('get a quote', 'click', 'mobile fixed request a quote');
    });

    $('.change-compare-status.add').on('click', function () {
        window.site.trackEvent('get a quote', 'click', 'add to My Showroom');
    });

    $('.slick-gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: true,
        asNavFor: '.slick-gallery-nav',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    fade: false,
                    asNavFor: null
                }
            }
        ]
    });

    $('.slick-gallery-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slick-gallery',
        centerMode: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.detail__options-tabs a').click(function (e) {
        e.preventDefault();

        $(this).closest('.tabs').find('li.active').removeClass('active');
        $(this).tab('show');
    });

    $(document).on('click', '.js-focus-on-input', function (e) {
        e.preventDefault();
        var scrollOffset = 130;
        if (Modernizr.mq('(min-width: 768px)'))
            scrollOffset = 100;
        $("html, body").animate({
            scrollTop: $('.js-input-focus').offset().top - scrollOffset
        }, 600);
        $('.js-focus-form').addClass('highlight');
    });

    $(window).scroll(function () {
        if (document.getElementById('pricing-container')) {
            var topPos = document.getElementById('pricing-container').getBoundingClientRect().top;

            if (Modernizr.mq('(min-width: 768px)')) {
                if (topPos < 0)
                    $('.vehicle-detail-preview').fadeIn();
                else
                    $('.vehicle-detail-preview').fadeOut();
            }
        }
    });

    showHideFixedQuoteBtn();

    $(window).scroll(function () {
        showHideFixedQuoteBtn();
    });

    $(document).on('click', '.js-open-mobile-accordion', function (e) {
        e.preventDefault();
        $('.js-open-mobile-accordion').removeClass('active');
        $k = $('.js-open-mobile-accordion').find('.icon');
        if ($k.hasClass('icon-chevron-up')) {
            $k.removeClass('icon-chevron-up');
        }

        $(".js-open-mobile-accordion-body:visible").slideUp();
        if (!$(this).next().is(":visible")) {
            $(this).next().slideDown();
            $(this).closest('.js-open-mobile-accordion').addClass('active');
            $(this).find('.icon').addClass('icon-chevron-up');
        }
    });

    $(document).on('click', '.js-open-mobile-inner-accordion .js-toggle-header-popover', function (e) {
        $target = $(this).data('trigger-panel');

        $('.js-open-mobile-inner-accordion .js-accordion-content').each(function () {
            if ($(this).prop('id') !== $target) {
                $(this).slideUp();
                $('[data-trigger-panel="' + $(this).prop('id') + '"] + span').removeClass('icon-chevron-up');
            }
        });
        $(this).closest('.js-open-mobile-inner-accordion').find('#' + $target).slideToggle();
    });
});

$(document).ready(function () {
    $('.detail-status').html('<div class="col-xs-24"><div class="detail-status-item"><span class="detail-status-item-label mod-sports-car">Free Mainland Delivery!</span></div></div>');
    $('<h2 class="vehicle-details-header">Vehicle Details & Custom Options</h2>').insertAfter('.detail-status');
    if ($(window).width() > 992) {
        $('.detail__action-btns').appendTo('#fixed-pricing');
        $('#pricing-result').addClass('stick-area');
    }

    if ($(window).width() < 767) {
        $('.detail__spec').parents('.visible-xs').insertAfter('.detail__image-gallery');
    }
});

$(document).on('click', '.tooltip-detail-toggle.mobile', function () {
    $('.tooltip-detail-toggle.mobile').removeClass('active');
    $('.tooltip-inner.mobile').removeClass('active');
    $(this).toggleClass('active');
    var target = $(this).data('target');
    $('.tooltip-inner.mobile#' + target).toggleClass('active');
});

$(document).on('click', '.close-tooltip', function () {
    $('.tooltip-detail-toggle.mobile').removeClass('active');
    $('.tooltip-inner.mobile').removeClass('active');
});

function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}